import { REQUEST } from '../../../constants/request';

export const initialPermission = {
  userSubscriptions: [],
  hasFollowed: false,
  hasBookmarked: false,
  channelCID: {
    orgId: '',
    streamId: '',
    channelId: '',
  },
  userRoleMapping: {
    userId: '',
    roles: [],
    mapping: [],
  },
  loading: REQUEST.idle,
};
export const initialChannel = {
  channelId: '',
  description: '',
  id: '',
  isFavourite: false,
  metadata: {
    coverPicUrl: '',
    createdAt: '',
    createdBy: '',
    itemsHash: '',
    profilePicUrl: '',
    subscriberCount: 0,
    type: '',
  },
  name: '',
  orgId: '',
  restricted: false,
  streamId: '',
  topics: [],
  locations: [],
  boosts: {},
  visible: false,
  primaryUseCase: null,
  userData: initialPermission,
};

export const initialHoveredChannel = {
  channel: {
    locations: [],
    topics: [],
    name: '',
    orgId: '',
    streamId: '',
    id: '',
    visible: true,
    description: '',
    boosts: {},
    restricted: false,
    metadata: {
      itemsHash: '',
      subscriberCount: 1,
      coverPicUrl: '',
      profilePicUrl: '',
      followerCount: 0,
      platformBoost: 0,
      createdAt: '',
      createdBy: '',
    },
  },
  minBoostTag: {
    content: 0,
    promotion: 0,
  },
  subscriptions: [],
  users: [],
  usersOnline: [],
  roles: [],
  moderators: [],
  budget: {
    content: 0,
    promotion: 0,
  },
  maxCostBoosts: {
    content: 0,
    promotion: 0,
  },
  moneyLeftForContent: null,
  allowedBoosts: [],
};

export const initialChannelBookmark = {
  isBookmark: false,
  selectedTags: [],
};
